var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loggedIn)?_c('div',[_c('a',{staticClass:"progressActive--text",attrs:{"href":"/login","title":"Login"}},[_vm._v("LOGIN")]),_c('span',{class:_vm.dark ? 'silver--text' : 'charcoal--text'},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }